import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { List } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import _sortBy from 'lodash/sortBy';
import { generateKey } from './SiteMap.utils';
import Link from '../../atoms/Link';
import { EVENT_CATEGORIES, EVENT_ACTIONS } from '../../modules/analytics/components/Event';
import { isExternalPage } from '../../services/pages';
import { SiteNavigationLinkPropType } from '../../services/proptypes';
import { classNames } from '../../utils/classname';
var defaultProps = {
  bulleted: false,
  horizontal: false,
  className: ''
};
export default function SiteMap(_ref) {
  var links = _ref.links,
    horizontal = _ref.horizontal,
    bulleted = _ref.bulleted,
    className = _ref.className;
  if (_isEmpty(links)) {
    return null;
  }
  var sortedLinks = _sortBy(links, ['navigationPriority', '_id']);
  var finalClassName = classNames(_defineProperty({
    sitemap: true
  }, className, className));
  return /*#__PURE__*/React.createElement(List, {
    horizontal: horizontal,
    bulleted: bulleted,
    className: finalClassName
  }, sortedLinks.map(function (_ref2) {
    var title = _ref2.title,
      pageType = _ref2.pageType,
      slug = _ref2.slug,
      url = _ref2.url,
      contentProps = _ref2.contentProps;
    var to = isExternalPage(pageType) ? url : slug;
    var key = generateKey(title, url, slug);
    return /*#__PURE__*/React.createElement(List.Item, {
      key: key
    }, /*#__PURE__*/React.createElement(List.Content, null, /*#__PURE__*/React.createElement(Link, {
      to: to,
      linkAs: "span",
      title: title,
      internal: !isExternalPage(pageType),
      contentProps: contentProps,
      event: {
        category: EVENT_CATEGORIES.FOOTER_EVENT_CATEGORY,
        action: EVENT_ACTIONS.FOOTER_SITEMAP_CLICK_EVENT_ACTION,
        label: title
      }
    })));
  }));
}
SiteMap.defaultProps = defaultProps;